import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from 'i18n/es';
import en from 'i18n/en';
import fr from 'i18n/fr';
import nl from 'i18n/nl';
import pl from 'i18n/pl';

import numeral from 'numeral';
import 'numeral/locales/es';
import 'numeral/locales/en-gb';
import 'numeral/locales/fr';
import 'numeral/locales/nl-nl';
import 'numeral/locales/pl';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment-timezone';
import 'moment/locale/es.js';
import 'moment/locale/fr.js';
import 'moment/locale/nl.js';
import 'moment/locale/en-gb.js';
import 'moment/locale/pl.js';
import {
  FALLBACK_LANG,
  LOCALES_MATCHES,
  NUMERAL_LOCALES_MATCHES
} from 'utils/constants/locales';
import { getLocalesMatcher } from 'utils/functions/locales';

i18n.on('languageChanged', lng => {
  numeral.locale(getLocalesMatcher(lng, NUMERAL_LOCALES_MATCHES));
  moment.locale(getLocalesMatcher(lng, LOCALES_MATCHES));
});

// the translations
const resources = {
  'en-GB': en,
  'es-ES': es,
  'fr-FR': fr,
  'nl-NL': nl,
  'pl-PL': pl,
  en_US: en,
  es_ES: es,
  fr_FR: fr,
  nl_NL: nl,
  pl_PL: pl,
  es: es,
  fr: fr,
  en: en,
  nl: nl,
  pl: pl
};

const languageDetector = new LanguageDetector(null, {
  order: [
    'navigator',
    'querystring',
    'cookie',
    'localStorage',
    'htmlTag',
    'path',
    'subdomain'
  ]
});

i18n
  .use(languageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: FALLBACK_LANG,
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
